// Form Submission Protection
//
// As long as counter > 0, prevent turbo from performing a visit in order to prevent form submission
// from being interrupted.
//
// Automatically increment and decrement the counter based on turbo form submissions. Manual
// incrementing and decrementing can be done by dispatching the `fsp:increment` and `fsp:decrement`
// events, which can be useful when working with third-party libraries that use non-turbo form
// submissions (i.e. Stripe).
//
// Example:
//   document.dispatchEvent(new CustomEvent("fsp:increment"))
//   document.dispatchEvent(new CustomEvent("fsp:decrement"))

let counter = 0
let refreshBlocked = false

function increment() {
  counter++
}

function decrement() {
  counter = Math.max(0, counter - 1)
}

function blockRefresh(event) {
  event.preventDefault()
  refreshBlocked = true
}

function reattemptRefresh() {
  refreshBlocked = false
  refresh()
}

function refresh() {
  const turboStream = document.createElement("turbo-stream");
  turboStream.setAttribute("action", "refresh");
  document.body.appendChild(turboStream);
}

function incrementEventListener(event) {
  increment()
}

function decrementEventListener(event) {
  decrement()

  if (counter === 0 && refreshBlocked)
    reattemptRefresh()
}

function refreshEventListener(event) {
  if (counter > 0)
    blockRefresh(event)
}

document.addEventListener("fsp:increment", incrementEventListener)
document.addEventListener("fsp:decrement", decrementEventListener)
document.addEventListener("turbo:submit-start", incrementEventListener)
document.addEventListener("turbo:submit-end", decrementEventListener)
document.addEventListener("turbo:before-visit", refreshEventListener)
